export default __webpack_public_path__ + "static/media/facebook.f5553378.svg";